<ng-container
  *ngIf="browseEntryAEMData && selectedBrowseEntry && !(!isAnon && isCustomerAvailable)"
>
  <div class="row container-full-width divider-b divider gray">
    <div class="col-12 m-t-md m-b-md" id="input-zip-container">
      <p
        class="text-center"
        *ngIf="changeState !== sharedBrowseConstants?.changeZipStaten && !isRap"
      >
        <span
          >{{ aemContent?.zipCodeText }} <b>{{ selectedBrowseEntry?.zip }}</b
          >.</span
        >&nbsp;
        <span>
          <a
            id="zip-code-updater"
            tabindex="{{ changeState ? -1 : 0 }}"
            attr.aria-label="{{ aemContent?.changeValue }}"
            (click)="changeZip()"
            [class.disabled]="changeState"
            href="javascript:void(0)"
            >{{ aemContent?.changeValue }}</a
          >
        </span>
      </p>
      <tmo-dynamic-modal
        [modal]="zipCodeModal"
        (onHide)="closeModal()"
        (onClose)="closeModal()"
        [styleClass]="'digital'"
        (onShow)="onShowZipCodeModal()"
        [displayModal]="changeState === sharedBrowseConstants?.changeZipState"
      >
        <ng-container header>
          <div class="modal-logo-close">
            <a
              tabindex="0"
              href="javascript:void(0)"
              class="close-x pull-right"
              (click)="closeModal()"
              id="cta-click-to-close-3"
            >
              <i class="fa fa-times-circle"></i>
            </a>
          </div>
          <div class="row digital">
            <div class="col-12">
              <h3>{{ aemContent?.updateLocation }}</h3>
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row digital">
            <div class="col-12 m-b-xl">
              <p [innerHTML]="aemContent?.updateLocationDisclaimer"></p>
            </div>
          </div>
          <div class="row digital" [formGroup]="changeZipForm">
            <div class="col-12">
              <div class="m-b-sm" *ngIf="apiError">
                <tmo-error-message-detail
                  [errorText]="browseEntryAEMData?.noAddressFound"
                  [formName]="'changeZipForm'"
                ></tmo-error-message-detail>
              </div>
              <tmo-floating-input
                [required]="true"
                [type]="'text'"
                (input)="onInput($event?.target?.value)"
                #zipCodeInput
                [pattern]="zipCodeRegexPattern"
                formControlName="zip"
                [autoFocus]="true"
                [isInputDirty]="!changeZipForm.controls.zip.valid"
                [fieldType]="fieldValidationConstants?.ZIP_CODE"
                (apiError)="(apiError)"
                [aria-label]="fieldValidationConstants?.ZIP_CODE"
                [id]="'tmo-input-default-153'"
                [customErrorText]="aemContent?.invalidZipCode"
              ></tmo-floating-input>
            </div>
            <div
              class="col-12 buttons-container-vertical button-spacing buttons-container-vertical"
            >
              <div class="button-box">
                <tmo-button
                  [button]="updateZipCodeButton"
                  [disabled]="disableConfirm"
                  (onSelect)="submitZipChange()"
                  >{{ aemContent?.updateZipCode }}
                </tmo-button>
              </div>
              <div class="button-box">
                <tmo-button [button]="cancelButton" (onSelect)="closeModal()"
                  >{{ aemContent?.cancel }}
                </tmo-button>
              </div>
            </div>
          </div>
        </ng-container>
      </tmo-dynamic-modal>
    </div>
  </div>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
</ng-container>
